import { observer } from 'mobx-react-lite'
import { useMindsetsStore } from './MindsetsStore'
import { namingConfigLowerCase } from '@gap/utils/config/naming-config'
import TextField from '@mui/material/TextField'
import Box from '@mui/material/Box'
import FileUploadWithProgress from 'reusable/mui/file-uploads/FileUploadWithProgress'
import { fileValidation, fileValidationDescription } from '@gap/utils/file/file-utils'
import GapAutocompleteMultiple from 'features/gap-components/autocomplete/multiple/GapAutocompleteMultiple'
import MindsetCategoryIcon from './MindsetCategoryIcon'
import { MindsetCategoryIconEnums } from '@gap/backend/app-services/mindset/models/MindsetCategoryEnum'
import GapDialog from 'reusable/gap-dialog/GapDialog'

export default observer(function MindsetsAddDialog() {
   const mindsetsStore = useMindsetsStore()
   const mindsetsDialogStore = mindsetsStore.mindsetsDialogStore

   return <GapDialog
      size='extra small'
      title={`${mindsetsDialogStore.mindset.id ? 'Update' : 'Create'} ${namingConfigLowerCase.mindset.singular}`}
      modalState={mindsetsStore.modifyMindsetModal}
      cancel={true}
      primary={{
         name: mindsetsDialogStore.mindset.id ? 'Update' : 'Publish',
         callback: mindsetsDialogStore.mindset.id ? mindsetsDialogStore.saveChanges : mindsetsDialogStore.add,
         loading: mindsetsDialogStore.loader.isLoading,
         notCloseAutomatically: true
      }}
      {...(!!mindsetsDialogStore.mindset.id ? {
         secondary: {
            name: 'Delete',
            variant: 'destroy',
            callback: mindsetsStore.deleteMindset,
            loading: mindsetsDialogStore.loader.isLoading,
            notCloseAutomatically: true
         }
      } : {})}
   >
      <Box gap={2} display="flex" flexDirection="column">
         {mindsetsDialogStore.formHandler.name.bindInput(ip =>
            <TextField placeholder='Name' fullWidth {...ip} />
         )}

         {mindsetsDialogStore.formHandler.description.bindInput(ip =>
            <TextField placeholder='Description' fullWidth {...ip} />
         )}

         {mindsetsDialogStore.formHandler.categories.bindInput(ip =>
            <GapAutocompleteMultiple
               options={mindsetsDialogStore.categoryOptions}
               label="Categories"
               {...ip}
            />
         )}

         <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
            {MindsetCategoryIconEnums.map(category => <MindsetCategoryIcon category={category} onClick={mindsetsDialogStore.setCategoryIcon} key={category} selected={category === mindsetsDialogStore.fields.categoryIcon} />)}
         </Box>

         <FileUploadWithProgress
            maxFiles={1}
            accept={fileValidation.mindsets.typeMap}
            subtext={fileValidationDescription.mindsets}
            files={mindsetsDialogStore.fileUpload.files}
            getPresignedUrl={mindsetsDialogStore.getMindsetImageUploadUrl}
            onFilesValidated={mindsetsDialogStore.onFileValidated}
            onFileRemove={mindsetsDialogStore.onFileRemove}
            formatFile={true}
         />

         {mindsetsDialogStore.formHandler.videoUrl.bindInput(ip =>
            <TextField placeholder='Video URL' fullWidth {...ip} />
         )}
      </Box>
   </GapDialog>
})
